import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

// the invitee view renders the editable form's own grid, just with disabled rows
export { Body, ReadOnlyValue, ScrollArea, Section } from './event-form.style';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
`;

// the element the propose-time popup positions itself against
export const ProposeAnchor = styled.div``;

export const RsvpRow = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};
`;

export const RsvpControl = styled.div`
  min-width: 12rem;
`;

export const ErrorText = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  flex-shrink: 0;
  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(4)} ${theme.spacing(3)}`};
  color: ${({ theme }) => theme.palette.error.main};
`;
